<template>
  <div>
    <section>
      <span class="fw-bolder text-primary">Wgraj plik z miejscami:</span>
      <loading v-model:active="isLoading" class="mt-5" />
      <input type="file" class="form-control" @change="onChange" />
      <xlsx-read :file="file">
        <xlsx-json :sheet="selectedSheet">
          <template #default="{collection}">
            <div v-show="collection !== null">
              <button class="btn btn-primary mt-3" @click="sendCollection(collection)">
                Wyślij miejsca do bazy
              </button>
            </div>
          </template>
        </xlsx-json>
      </xlsx-read>
    </section>
  </div>
</template>
<script>
import { XlsxRead, XlsxJson } from 'vue3-xlsx'
import Loading from 'vue-loading-overlay'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  components: {
    XlsxRead,
    Loading,
    XlsxJson
  },
  data () {
    return {
      file: null,
      isLoading: false
    }
  },
  methods: {
    onChange (event) {
      this.file = event.target.files ? event.target.files[0] : null
    },
    sendCollection (collection) {
      this.isLoading = true
      const postData = []
      for (const i in collection) {
        postData.push({
          name: collection[i].name,
          acronym: collection[i].name,
          address: `${collection[i].street}, ${collection[i].zip} ${collection[i].city}, ${collection[i].province}, ${collection[i].country}`,
          positionLatitude: isNaN(collection[i].latitude) ? 0 : collection[i].latitude,
          positionLongitude: isNaN(collection[i].longitude) ? 0 : collection[i].longitude,
          description: collection[i].type ?? ''
        })
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}Place`, postData, { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }).then(response => {
        console.log(response)
      }).catch(error => {
        console.log(error)
        Swal.fire('Coś poszło nie tak', '', 'success')
      }).finally(() => {
        this.isLoading = false
        Swal.fire('Zaimportowano arkusz miejsc', '', 'success')
      })
    }
  }
}
</script>
